import { useGraphql } from 'utils/hooks/useGraphql';
import { useTemplateAndContentFrequencyManagementSettings } from 'modules/frequencyManagement/lib/hooks/useTemplateAndContentFrequencyManagementSettings';
import { fetchTemplateMessageChannel } from 'modules/workflowNodeEditors/components/ChannelOptEditor/CHOChannelEditor/CHOChannelEditor.gql';

type State = {
  isIgnoreCapVisible: boolean;
  isIgnoreCapEditable: boolean;
};

const defaultState = {
  isIgnoreCapVisible: false,
  isIgnoreCapEditable: false,
};

export const useIgnoreCapAvailability = (templateId: number | undefined): State => {
  const { data: templateMessageChannel, isLoading: isLoadingTemplateMessageChannel } = useGraphql(
    fetchTemplateMessageChannel,
    {
      fetchPolicy: 'cache-and-network',
      variables: { templateId },
      skip: !templateId,
    },
  );

  const templateAndContent = templateMessageChannel?.templateAndContent;

  const { isTemplateFrequencyManagementEligible, isTemplateFrequencyManaged } =
    useTemplateAndContentFrequencyManagementSettings(templateAndContent);

  if (!templateAndContent || isLoadingTemplateMessageChannel) return defaultState;

  return {
    isIgnoreCapVisible: isTemplateFrequencyManagementEligible,
    isIgnoreCapEditable: isTemplateFrequencyManaged,
  };
};
